<template>
	<div id="carsuri-mark" class="carsuri-mark" v-if="mobile">
		<img src="static/img/mobile/btn_appdownload_m.png" @click="appdownload()" />
	</div>
</template>

<script>
export default {
	data() {
		return {
			mobile: false,
		}
	},
	created() {
		this.isMobile()
	},
	mounted() {
		document.addEventListener('scroll', this.scroll)
		window.addEventListener('resize', this.resize)
		this.$nextTick(() => {
			this.resize()
		})
	},
	methods: {
		resize(e) {
			this.isMobile()
			// if (!this.mobile) return
			// const pixels = window.innerHeight - 150
			// const scrollHeight = document.querySelector('html').scrollTop
			// document.getElementById('carsuri-mark').style.top = scrollHeight + pixels + 'px'
		},
		// scroll(e) {
		// 	this.isMobile()
		// 	if (!this.mobile) return
		// 	const pixels = window.innerHeight - 150
		// 	const scrollHeight = document.querySelector('html').scrollTop
		// 	document.getElementById('carsuri-mark').style.top = scrollHeight + pixels + 'px'
		// },
		isMobile() {
			var UserAgent = navigator.userAgent
			if (
				UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null ||
				UserAgent.match(/LG|SAMSUNG|Samsung/) != null
			) {
				this.mobile = true
				return true
			} else {
				this.mobile = false
				return false
			}
		},
		appdownload() {
			var varUA = navigator.userAgent.toLowerCase() //userAgent 값 얻기

			if (varUA.match('android') != null) {
				//안드로이드 일때 처리
				this.googleDown()
			} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
				//IOS 일때 처리
				this.appleDown()
			} else {
				//아이폰, 안드로이드 외 처리
			}
		},
		appleDown() {
			window.open('https://apps.apple.com/kr/app/%EC%B9%B4%EC%88%98%EB%A6%AC-%EC%9E%90%EB%8F%99%EC%B0%A8-%EC%B6%9C%EC%9E%A5%EC%A0%95%EB%B9%84-%EC%84%9C%EB%B9%84%EC%8A%A4/id968243793')
		},
		googleDown() {
			window.open('https://play.google.com/store/apps/details?id=com.dpc.carpro2')
		},
	},
}
</script>

<style scoped>
.carsuri-mark {
	position: fixed;
	bottom: 50px;
	z-index: 10002;
	right: 0;
	transition: 0.3s;
}
@media (min-width: 641px) {
	.carsuri-mark img {
		width: 200px;
		height: auto;
		cursor: pointer;
	}
}
@media (max-width: 640px) {
	.carsuri-mark img {
		width: 150px;
		height: auto;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/common/widget/CarsuriMark.vue